document.addEventListener('click', (event) => {
  const button = event.target.closest('.ux-sab__play');
  if (!button) return;

  const media = button.closest('[data-ux-sab-video]');
  if (!media) return;

  const video = media.querySelector('video');
  if (!video) return;

  media.classList.add('ux-sab--playing');
  video.controls = true;
  const playback = video.play();
  if (playback && typeof playback.catch === 'function') {
    playback.catch(() => {});
  }
});
